import React from 'react';
import "../../style/LandingPageStyle.css"
import Box from "@mui/material/Box";
import {Container} from "react-bootstrap";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import LinkMUI from "@mui/material/Link"; 

import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import IconButton from '@mui/material/IconButton';

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === "light"
                        ? theme.palette.grey[200]
                        : theme.palette.grey[800],
                p: 6,
                marginTop: 'auto' 
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="center">
                    
                                        {/* COLUNA 1: CONTACTOS E REDES SOCIAIS */}
                    <Grid item xs={12} sm={6} display="flex" justifyContent="center">
                        <Box> 
                            {/* Contactos */}
                            <Typography variant="h6" color="text.primary" gutterBottom>
                                Contactos
                            </Typography>
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                <LinkMUI href="mailto:sasilva@deec.uc.pt" color="inherit">sasilva@deec.uc.pt</LinkMUI>
                            </Typography>
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                <LinkMUI href="mailto:engenheiros4iu@gmail.com" color="inherit">engenheiros4iu@gmail.com</LinkMUI>
                            </Typography>

                            {/* Redes Sociais (Novo Bloco) */}
                            <Typography variant="h6" color="text.primary" sx={{ mt: 3, mb: 1 }}>
                                Redes Sociais
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1, ml: -1.5 }}>
                                <IconButton 
                                    component="a" 
                                    href="https://www.facebook.com/profile.php?id=61569099413178" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    aria-label="Facebook"
                                    sx={{ color: 'text.secondary', '&:hover': { color: '#1877F2' } }}
                                >
                                    <FacebookIcon fontSize="large" />
                                </IconButton>
                                
                                <IconButton 
                                    component="a" 
                                    href="https://www.linkedin.com/company/engenheiros4iu" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    aria-label="LinkedIn"
                                    sx={{ color: 'text.secondary', '&:hover': { color: '#0A66C2' } }}
                                >
                                    <LinkedInIcon fontSize="large" />
                                </IconButton>
                                
                                <IconButton 
                                    component="a" 
                                    href="https://www.instagram.com/engenheiros4iu/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    aria-label="Instagram"
                                    sx={{ color: 'text.secondary', '&:hover': { color: '#E4405F' } }}
                                >
                                    <InstagramIcon fontSize="large" />
                                </IconButton>
                            </Box>
                        </Box>
                    </Grid>

                    {/* COLUNA 2: APPS */}
                    <Grid item xs={12} sm={6} display="flex" justifyContent="center">
                        <Box>
                            <Typography variant="h6" color="text.primary" gutterBottom>
                                Apps (Disponível nas Lojas)
                            </Typography>
                            
                            {/* Box com display flex para pôr as coisas lado a lado */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4, mt: 1 }}>
                                
                                {/* Bloco Engenheiros */}
                                <Box>
                                    <Typography variant="body2" color="text.primary" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                        Engenheiros / Voluntários
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        <LinkMUI href="https://play.google.com/store/apps/details?id=com.socialite.lct.esf" target="_blank" rel="noopener" color="inherit">
                                            &rarr; Google Play
                                        </LinkMUI>
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        <LinkMUI href="https://apps.apple.com/pt/app/esf/id6738280971" target="_blank" rel="noopener" color="inherit">
                                            &rarr; App Store
                                        </LinkMUI>
                                    </Typography>
                                </Box>

                                {/* Bloco Associações */}
                                <Box>
                                    <Typography variant="body2" color="text.primary" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                        Associações
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        <LinkMUI href="https://play.google.com/store/apps/details?id=com.socialite.lct.esfa" target="_blank" rel="noopener" color="inherit">
                                            &rarr; Google Play
                                        </LinkMUI>
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        <LinkMUI href="https://apps.apple.com/pt/app/e4iu-associa%C3%A7%C3%B5es/id6504824800" target="_blank" rel="noopener" color="inherit">
                                            &rarr; App Store
                                        </LinkMUI>
                                    </Typography>
                                </Box>

                            </Box>
                        </Box>
                    </Grid>

                </Grid>

                {/* COPYRIGHT */}
                <Box mt={5}>
                    <Typography variant="body2" color="text.secondary" align="center">
                        {"Copyright © "}
                        <Link style={{ color: 'inherit', textDecoration: 'none' }} to="/">
                            Engenheiros4IU
                        </Link>{" "}
                        {new Date().getFullYear()}
                        {"."}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
